import { BeneficioApi as Api } from "./beneficio.api";
import { EnumEstadosBeneficios } from "../../../constants/beneficio.constants";

export class BeneficioRechazadosFacade {
  static countWithFilter({
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined
  }) {
    const filterDto = {
      busqueda,
      idComercio,
      subcategoria,
      estado: EnumEstadosBeneficios.RECHAZADO
    };

    return Api.countWithFilter(filterDto);
  }

  static getListWithFilter({
    desde = 1,
    hasta = 20,
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined
  }) {
    const filterDto = {
      busqueda,
      desde,
      hasta,
      idComercio,
      subcategoria,
      estado: EnumEstadosBeneficios.RECHAZADO
    };

    return Api.getListWithFilter(filterDto);
  }

  static getTipoDescuentoList() {
    return Api.getTipoDescuentoList();
  }

  static getUnidadesDescuentoList() {
    return Api.getUnidadesDescuentoList();
  }
}
